import { saveAbsenceChanges } from '../../services/absences';
import { notify } from '../../store/feedback';
import { refreshAbsences } from './refresh';

export default function absencesEditHandlers(deps, api) {
  const { session } = deps;

  // Modifie une absence existante (dates/type) : purge les feuilles d'heures liées à l'ancienne
  // période avant de resynchroniser sur la nouvelle, pour ne jamais laisser de résidu. Si le demandeur
  // modifie une demande déjà acceptée, elle repasse en attente (imposé par le trigger base
  // user_absences_protect_self_update, pas seulement ici) et les valideurs sont re-notifiés — on
  // repasse par le schéma de validation classique.
  async function updateAbsence(oldAbsence, { type, debut, debut_half, fin, fin_half }) {
    const isSelf = oldAbsence.user_id === session.user.id;
    // La demande est mise à jour AVANT de toucher aux feuilles d'heures : si l'update échoue, rien
    // n'est supprimé — l'ancienne période reste intacte plutôt que de purger des feuilles d'heures
    // valides pour une modification qui n'a en fait jamais eu lieu.
    const { data, error } = await saveAbsenceChanges(oldAbsence, {
      type,
      debut,
      debut_half,
      fin,
      fin_half,
    });
    if (error) {
      notify('Erreur modification absence : ' + error.message);
      return;
    }
    if (oldAbsence.statut === 'acceptee') await api.deleteAbsenceTimesheets(oldAbsence);
    if (data.statut === 'acceptee') await api.syncAbsenceTimesheets(data, oldAbsence.user_id);
    if (isSelf && oldAbsence.statut === 'acceptee' && data.statut === 'attente')
      api.notifyAbsenceModified(data);
    await refreshAbsences(deps, api);
  }

  return { updateAbsence };
}
